<template>
  <Modal ref="modal">
    <div class="profile">
      <div class="hero">
        <img :src="resolveImage(person.image)" width="350" />
      </div>
      <div class="heading">
        <span class="name"> {{ person.firstName }} {{ person.lastName }} </span>
        <span class="role">
          {{ person.title }}
        </span>
        <div class="actions">
          <font-awesome-icon :icon="faEnvelope" v-if="person.email" />
          <font-awesome-icon
            :icon="faLinkedin"
            v-if="person.linkedIn"
            @click="openInNewTab(person.linkedIn)"
          />
        </div>
      </div>
    </div>
    <p class="bio">
      {{ person.bio }}
    </p>
  </Modal>
</template>

<style scoped>
/* --- Layout wrapper --- */
/* Mobile-first: stack vertically (image on top, text below) */
.profile {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 16px;
}

/* Desktop/Tablet: side-by-side */
@media (min-width: 768px) {
  .profile {
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
  }
}

/* --- Hero image --- */
.hero {
  border-radius: 10px;
  overflow: hidden;
  max-width: 295px;
  max-height: 295px;
  flex: 0 0 auto; /* don't stretch the image column */
}
.hero img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover; /* keep aspect ratio and crop nicely */
}

/* Name, title, and icons */
.heading {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: left;
}

/* Make name prominent but keep inline */
.name {
  color: #083a5b;
  font-weight: 800;
  font-size: 1.6rem; /* slightly smaller so inline flows better */
  letter-spacing: 0.2px;
}

/* Title inline with name */
.role {
  color: #6b7280;
  font-size: 1.2rem;
  font-weight: 600;
}

/* Icons inline with name and title */
.actions {
  display: inline-flex;
  align-items: center;
  margin-top: 5px;
}

.actions > svg {
  font-size: 1.3rem;
  color: #3072a4;
  cursor: pointer;
}

.actions > svg:not(:first-child) {
  margin-left: 10px;
}

.disabled {
  cursor: not-allowed !important;
  color: rgb(0, 0, 0, 0.25) !important;
}

/* On larger screens, you may want a bigger name again */
@media (min-width: 768px) {
  .role {
    font-size: 1.5rem;
  }
  .actions {
    font-size: 1.5rem;
  }
}

/* Bio below heading */
.bio {
  overflow-y: auto;
  color: #6b7280;
  font-size: clamp(0.9rem, 5vw, 1.4rem);
  margin-top: 1.5rem;
  flex: 1 1 auto;
  min-height: 0;
  margin-bottom: 0;
}
</style>

<script setup>
import { reactive, ref } from "vue";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Modal from "./Modal.vue";

const modal = ref(null);
const person = reactive({
  image: "",
  firstName: "",
  lastName: "",
  title: "",
  email: "",
  linkedIn: "",
  bio: "",
});

const open = (nextPerson) => {
  Object.assign(person, nextPerson);
  modal.value?.open();
};

const close = () => {
  modal.value?.close();
};

const resolveImage = (fileName) => {
  fileName = fileName ? fileName : "NotProvided.png";
  return require(`@/assets/images/leadership/${fileName}`);
};

const openInNewTab = (url) => {
  window.open(url, "_blank");
};

defineExpose({
  open,
  close,
});
</script>
